import { Translations } from './types';

export const en: Translations = {
  sidebar: {
    welcome: 'Welcome,',
    logout: 'Logout',
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
    menuItems: {
      'Homepage': 'Homepage',
      'Bacheca': 'Board',
      'Eventi': 'Events',
      'Pubblicità': 'Advertising',
      'Invia Messaggi': 'Send Messages',
      'Clienti': 'Clients',
      'Matching': 'Matching',
      'Location': 'Locations',
      'Team': 'Team',
      'Contabilità': 'Accounting',
      'Agenzia Amore': 'Love Agency',
      'Dating Coach': 'Dating Coach',
      'Consulente d\'Immagine': 'Image Consultant',
      'Messaggeria': 'Messaging',
      'Tavoli': 'Tables',
      'Messaggi': 'Messages',
      'Consulenze': 'Consultations',
      'Corsi per Single': 'Singles Courses',
      'Viaggi per Single': 'Singles Travel',
      'Marketing': 'Marketing',
      'Altri Eventi': 'Other Events',
      'Speed Date': 'Speed Date',
      'Gestione Staff': 'Staff Management',
    },
  },
  profile: {
    tabs: {
      profile: 'Profile',
      settings: 'Settings',
      company: 'Company',
    },
    header: {
      name: 'Name',
      role: 'Role',
      city: 'City',
      notDefined: 'Not defined',
    },
    roles: {
      admin: 'Administrator',
      organizer: 'Organizer',
      pr: 'PR',
      collaboratore: 'Collaborator',
    },
    form: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone Number',
      city: 'City',
      emailReadonly: 'Email cannot be changed',
      phonePlaceholder: '+39 123 456 7890',
      cityPlaceholder: 'Enter city',
      changePassword: 'Change Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      newPasswordPlaceholder: 'Leave blank to keep current',
      confirmPasswordPlaceholder: 'Repeat new password',
      saving: 'Saving...',
      save: 'Save Changes',
    },
    settings: {
      notifications: 'Notifications',
      emailNotifications: 'Email Notifications',
      pushNotifications: 'Push Notifications',
      eventReminders: 'Event Reminders',
      security: 'Security',
      twoFactor: 'Two-Factor Authentication',
      language: 'Language',
      languageDescription: 'Select the admin interface language',
    },
    company: {
      title: 'Company Profile',
      companyName: 'Company Name',
      email: 'Email',
      phone: 'Phone',
    },
    messages: {
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      updateSuccess: 'Profile updated successfully',
      updateError: 'Error updating profile',
    },
  },
  homepage: {
    title: 'Homepage',
    loading: 'Loading...',
    stats: {
      totalEvents: 'Total Events',
      participants: 'Participants',
      locations: 'Locations',
      matches: 'Matches',
      totalClients: 'Total Clients',
      totalRevenue: 'Total Revenue',
      showRevenue: 'Show revenue',
      hideRevenue: 'Hide revenue',
    },
    recentEvents: 'RECENT EVENTS STATISTICS',
    upcomingEvents: 'UPCOMING EVENTS ITALY',
    table: {
      eventName: 'Event Name',
      ageRange: 'Age Range',
      date: 'Date',
      location: 'Location',
      city: 'City',
      participants: 'Participants',
      matches: 'Matches',
      menRevenue: 'Men Revenue',
      womenRevenue: 'Women Revenue',
      total: 'Total',
      men: 'M: ',
      women: 'W: ',
    },
    noEvents: 'No events scheduled',
    eventStatus: {
      soldOut: 'SOLD OUT + WAITING LIST',
      almostFull: 'ALMOST FULL',
      limitedSpots: 'LIMITED SPOTS',
      scheduled: 'SCHEDULED',
    },
  },
  login: {
    brand: 'FlashCrush',
    email: 'Email',
    password: 'Password',
    loggingIn: 'Logging in...',
    logIn: 'Log In',
    register: 'Register',
    forgotPassword: 'Forgot password?',
    registrationTitle: 'Registration',
    registrationDescription: 'Create a new account to participate in events.',
    fullName: 'Full Name',
    registering: 'Registering...',
    alreadyHaveAccount: 'Already have an account? Log in',
    resetPasswordTitle: 'Password Recovery',
    resetPasswordDescription: 'Enter your email to receive password reset instructions.',
    sending: 'Sending...',
    sendInstructions: 'Send instructions',
    backToLogin: 'Back to login',
    resetEmailSent: 'If the email address exists, you will receive instructions to reset your password.',
    errors: {
      invalidCredentials: 'Invalid credentials. Please check your email and password and try again.',
      emailNotConfirmed: 'Email not confirmed. Check your inbox for the confirmation link.',
      invalidEmailFormat: 'Invalid email format. Please enter a valid email address.',
      genericLoginError: 'An error occurred during login. Please try again later.',
      registrationError: 'Error during registration',
      resetPasswordError: 'Error during password recovery',
    },
  },
  auth: {
    pendingApproval: 'Your account is pending approval by an administrator.',
    accountRejected: 'Your account has been rejected. Contact the administrator for more information.',
    accountSuspended: 'Your account has been suspended. Contact the administrator for more information.',
    registrationComplete: 'Registration complete! Your account is pending approval by an administrator. You will receive a notification when you can log in.',
  },
  common: {
    loading: 'Loading...',
    error: 'Error',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    noResults: 'No results',
    back: 'Back',
    next: 'Next',
    hiddenAmount: '••••• €',
  },
};
